module.exports = __webpack_public_path__ + "img/banner.743210a2.jpg";